import * as yup from 'yup'

const schema = yup.object().shape({
  nonComplianceReportId: yup.string().required(),
  description: yup.string().required(),
})

export default schema
